<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

html,body,
#app{
  width: 100%;
  height: 100%;
  background-color: #f3f3f4;
}
</style>
